import {Member} from "../member/member";



export class ReservationTable {
  header : {
    text: string;
    count: number;
    filter: string;
  }[]
  subHeader: {
    text: string;
    filter: string;
  }[]
  roomsByBsc?: {}
  spaceByCc?: {}
  rooms: Room[]
} 

export class Room {
  id: number;
  size: string;
  goods: string;

  at_de: string;
  bsc_num: number;
  cc_cd: string;
  cd: string;
  credit_hh: number;
  dong: string;
  floor: string;
  nm: string;
  room: string;
  se: string;
  se_nm: string;

  policy: {
    cancelTime: number;
    times: {
      start: string;
      end: string;
    }[]
  };
}

export class RoomReservation {
  pblspc_cd: string;
  pblspc_nm: string;
  de_use: string;
  time_use_start: string;
  time_use_end: string;
  dtl: string;
  memo: string;
  dong: string;
  se: string;
  se_nm: string;
  floor: string;
  room: string;
  location: string;

  cc_cd?: string;
  cc_nm?: string;
  cd?: string;
  clt_cd?: string;
  clt_nm?: string;
  crt_count?: number;
  email?: string;
  mem_cd?: string;
  mem_nm?: string;
  rsv_date?: string;
  rsv_time?: string;
  stat?: string;
  stat_nm?: string;
  tel?: string;
  use_hh?: number;
  use_num?: number;
}


// export class RoomReservation {
//   id: number;
//   applicant: Member;
//   room: Room;
//   title: string;
//   date: string;
//   startTime: string;
//   duration: string;
//   participants: string[];
// }



// WEBPACK FOOTER //
// ./src/app/service/reservation/reservation.ts